<template>
  <v-container grid-list-md text-xs-center>
    <v-layout v-if="false" row wrap>
      <v-flex d-flex v-for="(info, idx) in infos" :key="idx" xs12 sm6 md4>
        <v-card dark class="elevation-10 ma-3">
          <v-card-title>{{idx}}</v-card-title>
          <v-card-text>{{info}}</v-card-text>
          <v-card-actions>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else row full-width>
      <v-card width="100%">
        <v-card-title primary-title class="headline">{{$t('system-status')}}</v-card-title>
        <v-list two-line>
          <span v-for="(info, idx) in infos" :key="idx">
            <v-list-tile v-if="objectNameToLabel(idx)">
              <v-list-tile-action>
                <v-icon>{{objectNameToIcon(idx)}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{objectValueToLabel(info)}}</v-list-tile-title>
                <v-list-tile-sub-title>{{objectNameToLabel(idx)}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </span>
        </v-list>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  created() {
console.log('HomePage Created');
  },
  mounted() {
    console.log('HomePage Mounted');
    this.$store.dispatch("info/fetchInfo").then(() => {
      console.log("Loading Info Complete");
    });
  },
  computed: {
    ...mapState("info", ["infos", "loading"])
  },
  methods: {
    objectNameToLabel(key) {
      switch (key) {
        case "hostname":
          return this.$t("system-status-hostname");
        case "wlan0_power":
          return this.$t("system-status-wlan0-power");
        case "wlan0_current_ssid":
          return this.$t("network-wlan0-current-connected");
        case "wlan0_current_address":
          return this.$t("network-wlan0-current-address");
        case "wlan0_current_macaddress":
          return this.$t("network-wlan0-current-macaddress");
        case "eth00_current_macaddress":
          return this.$t("network-eth0-current-macaddress");
        case 'eth0_current_address':
          return this.$t("network-eth0-current-address");
        case "eth0_current_macaddress":
          return this.$t("network-eth0-current-macaddress");
        case "current_dns":
          return this.$t("network-current-dns");

      }
      return null;
    },
    objectNameToIcon(key) {
      switch (key) {
        case "hostname":
          return 'laptop';
        case "wlan0_power":
          return 'wifi';
        case "wlan0_current_ssid":
          return 'settings_remote';
        case "wlan0_current_address":
        case 'eth0_current_address':
          return 'timeline';
        case "wlan0_current_macaddress":
        case "eth0_current_macaddress":
          return 'repeat';
        case "current_dns":
          return 'dns';

      }
      return 'extension';
    },
    objectValueToLabel(value) {
      switch (value) {
        case "on":
          return this.$t("system-status-on");
        case "off":
          return this.$t("system-status-off");
      }
      return value;
    }
  },

  data() {
    return {
      a: null
    };
  }
};
</script>

<style>
</style>
